module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>fb</title><path d=\"M28.48,50V27.22h2.63c1.44,0,2.89,0,4.33,0a.86.86,0,0,0,.65-.47c.4-2.77.74-5.55,1.12-8.43H28.58c0-2.46-.14-4.83,0-7.17.13-1.68,1.13-2.47,2.85-2.64,1.35-.14,2.71-.12,4.07-.16h1.92V.38c-.42,0-.85-.13-1.28-.15C33,.07,29.76-.35,26.61.61a10,10,0,0,0-7.23,9c-.17,2.55-.12,5.12-.17,7.68,0,.32,0,.64,0,1H11.59v8.9h7.55V49.94a5.35,5.35,0,0,1-.59.06\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/fb.svg
// module id = 9kx0
// module chunks = 1